import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import FrameworksBanner from "../components/FrameworksBanner";
// import Sidebar from "../components/Sidebar"; // if you have a dedicated Sidebar

export default function MainLayout() {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* NAVBAR - fixed positioned, so we use a spacer */}
      <Navbar />
      {/* Spacer for fixed navbar height (h-16 = 64px) */}
      <div className="flex-shrink-0 h-16" />

      {/* Launch notice — in normal flow, so it pushes content down without
          touching the navbar's fixed positioning. Self-removes on expiry. */}
      <FrameworksBanner />

      {/* MAIN CONTENT AREA - flex-1 with min-h-0 to allow shrinking in flex context */}
      <div className="flex flex-1 min-h-0">
        {/* If you have a left sidebar for large screens */}
        {/* <Sidebar /> */}

        {/* This is where your CIP content (and other pages) will show */}
        <main className="flex-1 min-h-0 overflow-auto bg-white print:overflow-visible">
          <Outlet />
        </main>
      </div>
    </div>
  );
}